@for (status of statuses; track status.channelUId) {
  <span
    >
    <span class="channel-state">
      <span
        class="state-color"
        [ngStyle]="{ 'background-color': status.color }"
      [title]="status.statusTitle"></span>
      <i
        class="icon {{ status.channelIcon }}"
      [title]="status.title"></i>
    </span>
  </span>
}
